// import { renderEmptyHandler } from 'choerodon-ui/lib/configure';
import intl from 'utils/intl';
import React, { ReactNode } from 'react';

export default (componentName?: string): ReactNode => {
  console.log('componentName', componentName);
  switch (componentName) {
    case 'Output':
      return '';
    case 'Attachment':
    // return 'no_attachments';
    // eslint-disable-next-line no-fallthrough
    case 'Table':
    return (
      <p style={{ padding: '4px', color: '#333333' }}>
        {intl.get('hzero.common.components.noticeIcon.null').d('暂无数据')}
      </p>
    );
    case 'Select':
    // return 'no_matching_results';
    // eslint-disable-next-line no-fallthrough
    default:
      return (
        <p style={{ padding: '4px', color: '#333333' }}>
          {intl.get('hzero.common.components.noticeIcon.null').d('暂无数据')}
        </p>
      );
  }
};
